// Centralized API Configuration
// This ensures consistent API URL resolution across all components

const getApiBaseUrl = (): string => {
  // First, try environment variable (only if it's not localhost in production)
  if (process.env.REACT_APP_API_BASE_URL) {
    const envUrl = process.env.REACT_APP_API_BASE_URL;
    // In production, ignore localhost environment variables
    if (process.env.NODE_ENV === 'production' && envUrl.includes('localhost')) {
      // Ignore localhost URLs in production, fall through to dynamic resolution
    } else {
      return envUrl;
    }
  }
  
  // For any browser environment, use the current origin
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    
    // Special case: if running locally on React dev server and need separate Express server
    if (origin.includes('localhost:3000') && process.env.NODE_ENV === 'development') {
      // For local development with separate Express server, use localhost:3001
      // But only if we're actually in local development mode
      return 'http://localhost:3001';
    }
    
    // For all other cases (production, Vercel, etc.), use current origin
    return origin;
  }
  
  // Fallback for server-side rendering
  return 'http://localhost:3000';
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URLs
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;
  return `${baseUrl}/${endpoint.startsWith('/') ? endpoint.slice(1) : endpoint}`;
};

// Debug logging (always show for debugging the deployment issue)
console.log('🔗 API Configuration:', {
  nodeEnv: process.env.NODE_ENV,
  envUrl: process.env.REACT_APP_API_BASE_URL,
  resolved: API_BASE_URL,
  origin: typeof window !== 'undefined' ? window.location.origin : 'SSR',
  isProduction: process.env.NODE_ENV === 'production'
});

export default API_BASE_URL;